// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__286tC","rootNoMargin":"styles_rootNoMargin__1lIKd"};